import { render, staticRenderFns } from "./ShareLandingView.vue?vue&type=template&id=57bd81f4&scoped=true"
import script from "./ShareLandingView.vue?vue&type=script&lang=js"
export * from "./ShareLandingView.vue?vue&type=script&lang=js"
import style0 from "./ShareLandingView.vue?vue&type=style&index=0&id=57bd81f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd81f4",
  null
  
)

export default component.exports